if (!customElements.get('product-accessory-bundle')) {
  customElements.define(
    'product-accessory-bundle',
    class ProductAccessoryBundle extends HTMLElement {
      constructor() {
        super();
        this.currency = this.dataset.currency || window.Shopify?.currency?.active || 'USD';
      }

      connectedCallback() {
        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('click', this.onClick.bind(this));
        this.updateState();
      }

      onChange(event) {
        const item = event.target.closest('[data-accessory-item]');
        if (!item) return;

        if (event.target.matches('[data-accessory-variant-select]')) {
          const option = event.target.selectedOptions[0];
          const checkbox = item.querySelector('[data-accessory-checkbox]');
          if (!option || !checkbox) return;

          checkbox.dataset.variantId = option.value;
          checkbox.dataset.price = option.dataset.price || '0';
          checkbox.disabled = option.dataset.available !== 'true';
          if (checkbox.disabled) checkbox.checked = false;

          const price = item.querySelector('[data-accessory-price]');
          const comparePrice = item.querySelector('[data-accessory-compare-price]');
          const priceCents = Number(option.dataset.price || 0);
          const compareCents = Number(option.dataset.compareAtPrice || 0);

          if (price) price.textContent = this.formatMoney(priceCents);
          if (comparePrice) {
            comparePrice.textContent = compareCents > priceCents ? this.formatMoney(compareCents) : '';
            comparePrice.classList.toggle('hidden', !(compareCents > priceCents));
          }

          const image = item.querySelector('.product-accessories__image');
          if (image && option.dataset.imageUrl) {
            image.src = option.dataset.imageUrl;
            image.removeAttribute('srcset');
          }
        }

        if (event.target.matches('[data-accessory-quantity]')) {
          const value = Math.max(1, parseInt(event.target.value, 10) || 1);
          event.target.value = value;
        }

        this.updateState();
      }

      onClick(event) {
        const minus = event.target.closest('[data-accessory-qty-minus]');
        const plus = event.target.closest('[data-accessory-qty-plus]');
        if (!minus && !plus) return;

        const item = event.target.closest('[data-accessory-item]');
        const input = item?.querySelector('[data-accessory-quantity]');
        if (!input) return;

        const current = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = plus ? current + 1 : Math.max(1, current - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      getSelectedItems() {
        return Array.from(this.querySelectorAll('[data-accessory-item]'))
          .map((item) => {
            const checkbox = item.querySelector('[data-accessory-checkbox]');
            const quantity = item.querySelector('[data-accessory-quantity]');
            if (!checkbox?.checked || checkbox.disabled || !checkbox.dataset.variantId) return null;

            return {
              id: Number(checkbox.dataset.variantId),
              quantity: Math.max(1, parseInt(quantity?.value, 10) || 1),
            };
          })
          .filter(Boolean);
      }

      resetSelection() {
        this.querySelectorAll('[data-accessory-checkbox]').forEach((checkbox) => {
          checkbox.checked = false;
        });
        this.updateState();
      }

      updateState() {
        let total = 0;
        let selectedCount = 0;

        this.querySelectorAll('[data-accessory-item]').forEach((item) => {
          const checkbox = item.querySelector('[data-accessory-checkbox]');
          const quantity = item.querySelector('[data-accessory-quantity]');
          const isSelected = Boolean(checkbox?.checked && !checkbox.disabled);
          item.classList.toggle('product-accessories__item--selected', isSelected);
          if (!isSelected) return;

          selectedCount += 1;
          total += Number(checkbox.dataset.price || 0) * Math.max(1, parseInt(quantity?.value, 10) || 1);
        });

        const totalElement = this.querySelector('[data-accessory-total]');
        if (totalElement) totalElement.textContent = this.formatMoney(total);

        const checkoutNote = this.querySelector('[data-accessory-checkout-note]');
        checkoutNote?.classList.toggle('hidden', selectedCount === 0);

        const productInfo = this.closest('product-info');
        this.syncAcceleratedCheckoutItems(productInfo);

        this.dispatchEvent(
          new CustomEvent('accessory-bundle:change', {
            bubbles: true,
            detail: { selectedCount, total },
          })
        );
      }


      syncAcceleratedCheckoutItems(productInfo) {
        if (!productInfo) return;

        const productForm = productInfo.querySelector('form[data-type="add-to-cart-form"]');
        if (!productForm) return;

        productForm
          .querySelectorAll('[data-product-accessory-additional-item]')
          .forEach((input) => input.remove());

        const selectedItems = Array.from(productInfo.querySelectorAll('product-accessory-bundle')).flatMap(
          (bundle) => bundle.getSelectedItems?.() || []
        );

        selectedItems.forEach((item, index) => {
          const itemIndex = index + 1;

          const idInput = document.createElement('input');
          idInput.type = 'hidden';
          idInput.name = `shopify-additional-items[${itemIndex}][id]`;
          idInput.value = String(item.id);
          idInput.dataset.productAccessoryAdditionalItem = 'true';
          productForm.appendChild(idInput);

          const quantityInput = document.createElement('input');
          quantityInput.type = 'hidden';
          quantityInput.name = `shopify-additional-items[${itemIndex}][quantity]`;
          quantityInput.value = String(item.quantity || 1);
          quantityInput.dataset.productAccessoryAdditionalItem = 'true';
          productForm.appendChild(quantityInput);
        });
      }

      formatMoney(cents) {
        const locale = document.documentElement.lang || 'en-US';
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: this.currency,
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return `${this.currency} ${((Number(cents) || 0) / 100).toFixed(2)}`;
        }
      }
    }
  );
}
